import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

import { GenericAccordion } from './generic-accordion.model';

@Injectable()
export class GenericAccordionService {

  constructor(private http: HttpClient) { }


}
